import { useEffect, useState } from "react";
import { findProductsAllEvent } from "../../_events/products/findProducts.event";
import { message } from "antd";
import AutoSelect from "./auto_select";
import { Grid } from "@mui/material";

const AutoSelectProductLoaded = (props) => {

    const { onChange } = props;

    const [ products, setProducts ] = useState([]);

    useEffect(() => {
        findProductsAllEvent()
        .then(json => {
            setProducts(json.list);
        })
        .catch(err => {
            message.error(err.message);
        });
    }, []);

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <AutoSelect
                    id='order_product_autoselect'
                    label='Producto'
                    getOptionLabel={(option) => `${option ? option.ref : ''}`}
                    renderOption={(props, option) => {
                        if(option){
                            return(<div {...props}>{`${option?.ref}`}</div>);
                        }
                    }}
                    data={products}
                    onChange={(value) => {
                        if(value) onChange?.(value.uuid);
                    }}
                />
            </Grid>
        </Grid>
    );
}

export default AutoSelectProductLoaded;